import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { Empty, ErrorBox, PageHead } from "../components/Bits";
import { Badge, Card } from "../design-system/components";
import { endpoints } from "../lib/api";
import { formatDate, pct, recordText } from "../lib/format";

export function DecksPage() {
  const decks = useQuery({ queryKey: ["decks"], queryFn: endpoints.decks });
  const analytics = useQuery({ queryKey: ["analytics"], queryFn: () => endpoints.analytics() });
  if (decks.error) return <ErrorBox error={decks.error} />;
  const rows = decks.data?.decks ?? [];
  return (
    <div className="rk-stack">
      <PageHead title="Decks" subtitle="Every deck you've played, with its version history." />
      {rows.length === 0 ? (
        <Card>
          <Empty title="No decks yet">
            <p>
              Decks are created automatically from debug exports, or when you link a game to a deck
              on upload.
            </p>
          </Empty>
        </Card>
      ) : (
        <div className="rk-cardgrid">
          {rows.map((deck) => {
            const stats = analytics.data?.decks.find((d) => d.deckId === deck.deckId);
            const winRate =
              stats?.winRate ??
              (deck.record.games > 0 ? (deck.record.wins / deck.record.games) * 100 : null);
            return (
              <Link
                key={deck.deckId}
                to={`/decks/${deck.deckId}`}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <Card
                  hover
                  title={deck.name}
                  description={`v${deck.latestVersion} · updated ${formatDate(deck.updatedAt)}`}
                  actions={deck.archived ? <Badge variant="completed">archived</Badge> : undefined}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: 8,
                      textAlign: "center",
                      marginBottom: 12,
                    }}
                  >
                    <div>
                      <div className="rk-big">{deck.record.games}</div>
                      <div className="rk-lbl">Games</div>
                    </div>
                    <div>
                      <div className="rk-big">{recordText(deck.record)}</div>
                      <div className="rk-lbl">Record</div>
                    </div>
                    <div>
                      <div className="rk-big">{pct(winRate)}</div>
                      <div className="rk-lbl">Win rate</div>
                    </div>
                  </div>
                  <div className="rk-winbar">
                    <span style={{ width: `${winRate ?? 0}%` }} />
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
